import { getShelfQuaternion } from '@components/storeMap/floor/3d/util'
import { buildFacingGeometry, quaternionToRotationMatrix, type FacingWithGeometry } from '@utils/geometry.ts'

import type { TransformedLayoutResponse } from '@state/layout/types'

/**
 * Builds a map of globalized facings with their 3D geometry.
 *
 * Takes transformed layout shelves and calculates the global 3D coordinates
 * and geometry for each facing.
 *
 * Type flow: TransformedLayoutResponse → Map<facingId, FacingWithGeometry>
 *
 * @param layout - The transformed layout with geometrically transformed shelves
 * @returns Map of facing IDs to their geometry data
 */
export function applyFacingGeometryTransformation(
  layout: TransformedLayoutResponse
): Map<string, FacingWithGeometry> {
  const facingGeometries = new Map<string, FacingWithGeometry>()

  for (const shelf of layout.shelves) {
    const rotationMatrix = quaternionToRotationMatrix(shelf.rotation)
    const quaternion = getShelfQuaternion(shelf.rotation)

    for (const layer of shelf.layers) {
      for (const facing of layer.facings) {
        facingGeometries.set(facing.id, buildFacingGeometry({
          shelf,
          layer,
          facing,
          rotationMatrix,
          quaternion,
        }))
      }
    }
  }

  return facingGeometries
}

